import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Performance } from '../model/recital';

export const addStudentsToPerformanceAPI = async (
  actId: string,
  performanceId: string,
  studentIds: string[],
) => {
  const response = await baseAPI.post<Performance>(
    `/acts/${actId}/performances/${performanceId}/students`,
    { studentIds },
  );
  return response.data;
};

export const useAddStudentsToPerformanceMutation = () => {
  return useMutation({
    mutationFn: async ({
      actId,
      performanceId,
      studentIds,
    }: {
      actId: string;
      performanceId: string;
      studentIds: string[];
    }) => {
      return await addStudentsToPerformanceAPI(
        actId,
        performanceId,
        studentIds,
      );
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PERFORMANCES, variables.performanceId],
      });
    },
  });
};
